// extracted by mini-css-extract-plugin
export default {"fav-item":"favItem_fav-item__Ud1wk","summary":"favItem_summary__F6lcG","descr":"favItem_descr__-GutQ","amount":"favItem_amount__9s2Za","actions":"favItem_actions__askta"};